// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { Link } from "gatsby";

import { getButtonClassNames, buttonModifiers, styles as buttonStyles } from "react-components/src/Button";

import { buildModifierClassNames } from "../../helpers/modifiers";

import styles from "./styles.css";

const supportedModifiers = ["button", "disabled", "link"].concat(buttonModifiers.map((m) => `button-${m}`));

function AnchorLink({ children, className, disabled, modifiers = [], href, target, ...rest }) {
    const isButton = modifiers.indexOf("button") > -1;
    const componentStyle = isButton ? buttonStyles.Button : styles.AnchorLink;

    const activeModifiers = modifiers
        .filter((m) => (isButton ? m.startsWith("button") : !m.startsWith("button")))
        .concat(disabled ? ["disabled"] : []);

    const modifierClassNames = isButton
        ? getButtonClassNames(activeModifiers)
        : buildModifierClassNames({
              modifiers: activeModifiers,
              rootClassName: "AnchorLink",
              styles,
          });

    const classString = cn(className, componentStyle, ...modifierClassNames);

    let externalLinkAttrs = {};
    if (target) {
        externalLinkAttrs = {
            target,
            rel: href.startsWith("http") ? "noopener noreferrer" : "noopener",
        };
    }

    if (disabled) {
        return <span className={classString}>{children}</span>;
    }

    // Only use Gatsby Links for blog urls. Other links should reload and be served via Framer
    if (href.indexOf("/blog") === 0) {
        return (
            <Link className={classString} to={href} {...externalLinkAttrs} {...rest}>
                {children}
            </Link>
        );
    }

    return (
        <a className={classString} href={href} {...externalLinkAttrs} {...rest}>
            {children}
        </a>
    );
}

AnchorLink.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string.isRequired,
    modifiers: PropTypes.arrayOf(PropTypes.oneOf(supportedModifiers)),
    target: PropTypes.string,
};

export default AnchorLink;
